<div
  class="menu-container"
  [attr.data-size]="size"
  [attr.data-variant]="variant"
  [attr.data-spacing]="spacing"
  [attr.data-disabled]="disabled"
  [attr.data-loading]="loading"
  [attr.data-open]="isOpen"
>
  <!-- Menu Content -->
  <div
    class="menu-content"
    [attr.role]="'menu'"
    [attr.aria-label]="ariaLabel || label || 'Menu'"
    [attr.aria-expanded]="isOpen"
    [attr.tabindex]="disabled ? -1 : 0"
    (keydown)="onKeyDown($event)"
  >
    <!-- Loading State -->
    <div *ngIf="loading" class="menu-loading">
      <div class="loading-spinner">
        <umss-icon
          name="phosphorCircleNotch"
          size="24px"
          class="spinner-icon"
        ></umss-icon>
      </div>
    </div>

    <!-- Menu Items -->
    <div *ngIf="!loading" class="menu-items">
      <ng-content></ng-content>
    </div>
  </div>

  <!-- Click Outside Handler -->
  <div
    *ngIf="isOpen"
    class="menu-backdrop"
    (click)="onClickOutside()"
    tabindex="0"
    role="button"
    (keydown.enter)="onClickOutside()"
    (keydown.space)="onClickOutside()"
  ></div>
</div>
